export const formatInternalRemarks = ({
  remarks,
  timestamp = new Date()
}: {
  remarks: string;
  timestamp?: Date;
}): string => {
  const date = timestamp.toLocaleString('en-PH', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });

  return `${remarks} (${date})`;
};

export const appendInternalRemarks = (
  existing: string | undefined,
  newRemark: string
): string => {
  if (!existing) {
    return newRemark;
  }

  return `${existing} | ${newRemark}`;
};
